  setTimeout(function() {

let customHTMLMask = '<div class="custom-masking-rc"><div class="custom-masking-rc-wrapper">';

document.querySelectorAll('.recharge-subscription-widget .rc-template__radio .rc-radio').forEach(function (radio) {
   
    const input = radio.querySelector('input');
    const inputVal = input.value;
    const inputID = input.id;

    const label = radio.querySelector('.rc-radio__label');
    const clonedLabel = label.cloneNode(true); // deep clone
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(clonedLabel);
    var checked = '';
    if(inputVal == 'onetime'){
      checked = 'checked'
    }
    customHTMLMask += `
        <label for="input-${inputVal}" data-target="${inputID}">
            <input type="radio" name="custom-trigger" ${checked} value="${inputVal}" id="input-${inputVal}"/>
            ${tempDiv.innerHTML}
        </label>
    `;
});

customHTMLMask += '</div>';

// Check for selling plans select
const sellingPlansWrapper = document.querySelector('.recharge-subscription-widget .rc-template__radio .rc-selling-plans');
if (sellingPlansWrapper) {
    const selectEl = sellingPlansWrapper.querySelector('select');
    const clonedSelect = selectEl.cloneNode(false);
    const selectId = selectEl.id;

    let customSelect = `<select name="custom-select" id="frequency-select" data-target="${selectId}">`;

    selectEl.querySelectorAll('option').forEach(function (option) {
        const label = option.textContent;
        const value = option.value;
        customSelect += `<option value="${value}">${label}</option>`;
    });

    customSelect += '</select>';

    customHTMLMask += `
        <div class="custom-frequency-wrapper">
            <label for="frequency-select">
                Send Every
                ${customSelect}
            </label>
        </div>
    `;
}

customHTMLMask += '</div>';

// Prepend to .product__app-block
const rechargeWidget = document.querySelector('.recharge-subscription-widget');
if (rechargeWidget) {
    const appBlock = rechargeWidget.closest('.product__app-block');
   const quantityWrapper = document.querySelector(".quantity__wrapper");

    if (quantityWrapper) {
        // Create a flex container
        const flexRow = document.createElement('div');
        flexRow.className = 'quantity-frequency-row';
        flexRow.style.display = 'flex';
        flexRow.style.gap = '1rem'; // Adjust spacing as needed
        flexRow.style.alignItems = 'center'; // Optional: aligns vertically

        // Move quantity wrapper into it
        quantityWrapper.parentNode.insertBefore(flexRow, quantityWrapper);
        flexRow.appendChild(quantityWrapper);

        // Extract frequency wrapper from customHTMLMask
        const parser = new DOMParser();
        const doc = parser.parseFromString(customHTMLMask, 'text/html');
        const frequencyWrapper = doc.querySelector('.custom-frequency-wrapper');

        if (frequencyWrapper) {
            flexRow.appendChild(frequencyWrapper);
        }
    }

    // Insert the rest of the mask minus the frequency wrapper
    const cleanedCustomHTML = customHTMLMask.replace(/<div class="custom-frequency-wrapper">[\s\S]*?<\/div>/, '');
    appBlock.insertAdjacentHTML('afterbegin', cleanedCustomHTML);
}



document.addEventListener('click', function(event) {
    const label = event.target.closest('.custom-masking-rc-wrapper label');
    if (label) {
        const targetId = label.getAttribute('data-target');
        const targetInput = document.getElementById(targetId);
        if (targetInput) {
            targetInput.click();
        }
    }
});

const _freqSel = document.getElementById('frequency-select');
if (_freqSel) _freqSel.addEventListener('change', function() {
  const selectedValue = this.value;
  const sellingPlanSelect = document.querySelector('select[name="rc_selling_plan"]');
  const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
  if (sellingPlanSelect) {
    sellingPlanSelect.value = selectedValue;
    sellingPlanInput.value = selectedValue;
  }
});

    
const priceElement = document.querySelector('.rc-radio__price');

  // Select the button where price should appear
  const button = document.querySelector('.button-with-price');
  const productForm = (typeof product_form_id !== 'undefined') ? document.getElementById(product_form_id) : null;
  const submitButton = document.getElementById('subcription-cart-button');

  if (priceElement && button) {
    // Get the price text from the price element
    const priceText = priceElement.textContent.trim();

    // Append or set the price text inside the button
    // Example: "Buy Now - $19.99"
    button.textContent = `${priceText}`;
  }

    if (submitButton && productForm) submitButton.addEventListener('click', function () {
      productForm.submit();
    });
  

    const radios = document.querySelectorAll('input[name="custom-trigger"]');
  const frequencySelect = document.getElementById('frequency-select');

  if (!frequencySelect) return;

  function toggleFrequencySelect() {
      const frequencySelect = document.getElementById('frequency-select');
    frequencySelect.removeAttribute('disabled');
    const selected = document.querySelector('input[name="custom-trigger"]:checked');
    console.log( selected, selected.value);
    if (selected && selected.value == 'subscription') {
      document.querySelector('input[name="selling_plan"]').value=frequencySelect.value;
      frequencySelect.removeAttribute('disabled');
    } else {
      document.querySelector('input[name="selling_plan"]').value='';
      frequencySelect.setAttribute('disabled', 'true');
    }
  }

  // Run once on page load
  toggleFrequencySelect();

  // Add change listener to all custom-trigger radios
  radios.forEach(function (radio) {
    radio.addEventListener('change', toggleFrequencySelect);
  });
    
}, 2000); // Delay in milliseconds
